import * as React from "react";
import * as Helpers from "../helpers";
import styles from "./InputText.module.scss";

type InputTextProps = InputProps & {
    type?: React.HTMLInputTypeAttribute | "textarea";
    rows?: number;
    step?: number;
    min?: number;
    max?: number;
    autoComplete?: string;
    disabled?: boolean;
    valueSuffix?: string;
}

const InputText: React.FunctionComponent<InputTextProps> = props => {
    const isRequired = props.required === true || (Array.isArray(props.required) && props.required.indexOf("required") !== -1);
    const showValidation = !Helpers.TriggerValidationSingle((props.value || "").trim(), props.required) && props.validation_triggered;
    const elemRef = React.useRef<HTMLDivElement>(null);
    if (showValidation && !props.validation_get_scrolled() && elemRef.current) {
        props.validation_set_scrolled();
        elemRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    }

    const value = props.value || (props.type === "range" ? props.min : "");

    function getInputElement()
    {
        switch( props.type ) {
            case "textarea":
                return <textarea
                    className={`form-control ${styles.formControl}`}
                    id={props.name}
                    name={props.name}
                    value={value}
                    autoComplete={props.autoComplete}
                    required={isRequired}
                    rows={props.rows}
                    onChange={(ev) => (props.update_value(props.name, ev.currentTarget.value))}
                    disabled={!!props.disabled}
                />;
                case "range":
                return <div className={styles.rangeWrapper}>
                    <input
                        className={`form-control ${styles.formControl}`}
                        id={props.name}
                        name={props.name}
                        type={props.type ?? "text"}
                        value={value}
                        autoComplete={props.autoComplete}
                        step={props.step ?? ''}
                        min={props.min ?? ''}
                        max={props.max ?? ''}
                        required={isRequired}
                        onChange={(ev) => (props.update_value(props.name, ev.currentTarget.value))}
                        disabled={!!props.disabled}
                    />
                    <div className={styles.rangeDescription}>
                        <strong>{value}</strong> {props.valueSuffix}
                    </div>
                </div>;
            default:
                return <input
                    className={`form-control ${styles.formControl}`}
                    id={props.name}
                    name={props.name}
                    type={props.type ?? "text"}
                    value={value}
                    autoComplete={props.autoComplete}
                    step={props.step ?? ''}
                    min={props.min ?? ''}
                    max={props.max ?? ''}
                    required={isRequired}
                    onChange={(ev) => (props.update_value(props.name, ev.currentTarget.value))}
                    disabled={!!props.disabled}
                />
        }
    }

    return <div ref={elemRef} className={styles.outer}>
        <div className={`${styles.wrapper} ${showValidation ? styles.hasValidation : ""}`}>
            <label htmlFor={props.name}>
                {props.label} {props.required ? <sub className={styles.required}>*</sub> : null}
            </label>
            {getInputElement()}
        </div>
        {props.description}
        {showValidation ? <div className={styles.validation} role="alert">{props.validation_message ? <>{props.validation_message}</> : <>Please enter a <span style={{ textTransform: "lowercase" }}>{props.label}</span>.</>}</div> : null}
    </div>
}

export default InputText;